
import PropTypes from 'prop-types'
import React from 'react'
import './table.css'

const Table = props => {
  const { table } = props
  const head = []
  const body = []

  for (const prop in table) {
    if (!table.hasOwnProperty(prop)) continue // smelly
    const value = table[prop]
    head.push(<th key={`__info_sheet_table_head_${prop}`}>{prop}</th>)
    body.push(<td key={`__info_sheet_table_body_${prop}`}>{value}</td>)
  }

  return (
    <div className='InfoSheetTable'>
      <table>
        <thead><tr>{head}</tr></thead>
        <tbody><tr>{body}</tr></tbody>
      </table>
    </div>
  )
}

Table.propTypes = {
  table: PropTypes.object.isRequired
}

Table.displayName = 'InfoSheet Table'

export default Table



// WEBPACK FOOTER //
// ./ui/InfoSheet/components/table.js